import React from "react";

export default function DotChart({ caption }) {
  return (
    <figure className="border-2 border-current p-6 my-10" data-testid="dotchart">
      <div
        className="relative h-64 w-full"
        style={{
          backgroundImage:
            "radial-gradient(circle, currentColor 1.3px, transparent 1.5px)",
          backgroundSize: "9px 9px",
        }}
        aria-label="Dot chart: a single center dot represents the firepower of all of World War II; every other dot is part of today's nuclear arsenal"
      >
        <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-4 w-4 rounded-full bg-[hsl(var(--primary))] ring-4 ring-[hsl(var(--background))]" />
      </div>
      <figcaption className="mt-4 font-display uppercase tracking-widest text-[0.7rem] opacity-80">
        {caption}
      </figcaption>
    </figure>
  );
}
